import { FIRE_INIT_SUCCESS, FIRE_INIT_FAIL, FIRE_INIT_LOADING } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
import http from '@/utils/ajax'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [FIRE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [FIRE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [FIRE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async fireManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.fireManagement
    commit(FIRE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(FIRE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(FIRE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
